<template>
  <v-menu offset-y :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn small text outlined v-on="on" :attrs="attrs" color="primary"
        ><v-icon>mdi-view-column</v-icon>Display</v-btn
      >
    </template>
    <v-card max-width="400px" style="overflow-y: auto">
      <v-card-text>
        <v-checkbox
          :input-value="isAllSelected"
          @change="selectAll"
          dense
          hide-details
          :disabled="isAllSelected"
          ><template v-slot:label
            ><span class="text-caption">Select All</span></template
          ></v-checkbox
        >
        <v-divider></v-divider>
        <v-row dense justify="start">
          <v-col
            v-for="item in sortedColumns"
            :key="item.text"
            cols="12"
            sm="6"
            class="py-0"
          >
            <v-checkbox
              v-model="selectedColumns"
              :value="item.value"
              dense
              hide-details
              ><template v-slot:label
                ><span class="text-caption">{{ item.text }}</span></template
              ></v-checkbox
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: ["columns"],
  data() {
    return {
      selectedColumns: this.columns.map((x) => x.value),
    };
  },
  mounted() {
    this.$store.dispatch("plansModule/setDisplayColumns", this.selectedColumns);
  },
  computed: {
    sortedColumns() {
      return this.columns.slice().sort((a, b) => a.text.localeCompare(b.text));
    },
    isAllSelected() {
      return this.selectedColumns.length == this.sortedColumns.length;
    },
  },
  methods: {
    selectAll() {
      this.selectedColumns = this.columns.map((x) => x.value);
    },
  },
  watch: {
    selectedColumns() {
      this.$store.dispatch(
        "plansModule/setDisplayColumns",
        this.selectedColumns
      );
    },
  },
};
</script>
